export default "__VITE_ASSET__Cq9UFFuI__"